import { z } from "zod/v3";

// Top-level regex for price validation
const PRICE_REGEX = /^\d{1,3}\.\d{2}$/;

const priceSchema = z
  .string()
  .nullable()
  .refine((value) => {
    if (value === "" || value === null) {
      return true;
    }

    return PRICE_REGEX.test(value);
  })
  .transform((v) => v || undefined)
  .default("0.00");

export const itemSchema = z.object({
  name: z.string().min(1, "Item name required").max(40),
  shortName: z.string().max(40),
  imageUrl: z
    .string()
    .max(256)
    .url()
    .nullable()
    .transform((v) => (v === "" ? null : v)),
  description: z.string().max(2048),
  price: z.union([priceSchema, z.record(z.string().cuid2(), priceSchema)]),
  isOutOfStock: z.boolean(),
  categories: z
    .array(z.string().cuid2())
    .min(1, "Choose a menu category for this item"),
  modifierGroups: z.array(z.string().cuid2()),
  useCategoryModifiers: z.boolean(),
  devicesIds: z.array(z.string()),
  taxCategoryId: z.string().cuid2().nullable(),
  salesCategoryId: z.string().cuid2().nullable(),
});

export const existingItemsFormSchema = z.object({
  items: z.array(z.string().cuid2()).min(1, "Select items to be added"),

  categories: z
    .array(z.string().cuid2())
    .min(1, "Choose a menu category for these items"),
});
